import React, { useState } from "react";
import LeftPanel from "../components/BuildPrice/LeftPanel";
import CenterPanel from "../components/BuildPrice/CenterPanel";
import RightPanel from "../components/BuildPrice/RightPanel";
import "../styles/BuildPrice.css";

const BuildPrice = () => {
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedTrim, setSelectedTrim] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedAccessories, setSelectedAccessories] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [rightTab, setRightTab] = useState("options"); // "options" or "offers"
  const [hoveredModel, setHoveredModel] = useState(null);
  const [hoveredTrim, setHoveredTrim] = useState(null);

  // Reset right panel when trim changes
  React.useEffect(() => {
    setSelectedColor(null);
    setSelectedAccessories([]);
    setSelectedPackage(null);
    setSelectedOffer(null);
    setRightTab("options");
  }, [selectedTrim]);

  return (
    <div className="build-price-layout">
      <LeftPanel
        selectedClass={selectedClass}
        setSelectedClass={setSelectedClass}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedTrim={selectedTrim}
        setSelectedTrim={setSelectedTrim}
        hoveredModel={hoveredModel}
        setHoveredModel={setHoveredModel}
        hoveredTrim={hoveredTrim}
        setHoveredTrim={setHoveredTrim}
      />
      <CenterPanel
        selectedClass={selectedClass}
        selectedModel={selectedModel}
        selectedTrim={selectedTrim}
        selectedColor={selectedColor}
        selectedAccessories={selectedAccessories}
        selectedPackage={selectedPackage}
        selectedOffer={selectedOffer}
        hoveredModel={hoveredModel}
        hoveredTrim={hoveredTrim}
      />
      <aside className={`right-panel-animate${selectedTrim ? " visible" : ""}`}>
        {selectedTrim && (
          <RightPanel
            selectedTrim={selectedTrim}
            selectedColor={selectedColor}
            setSelectedColor={setSelectedColor}
            selectedAccessories={selectedAccessories}
            setSelectedAccessories={setSelectedAccessories}
            selectedPackage={selectedPackage}
            setSelectedPackage={setSelectedPackage}
            selectedOffer={selectedOffer}
            setSelectedOffer={setSelectedOffer}
            rightTab={rightTab}
            setRightTab={setRightTab}
          />
        )}
      </aside>
    </div>
  );
};

export default BuildPrice;